import { getLeFEOrigin } from '@utils/util';

export const LbgJobLeFE = () => (
    <iframe className="admin-iframe" title="LBG job查询" src={`${getLeFEOrigin()}/#/app/admin/lbg_job_query`} />
);
